import React from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, IconAttention } from '@payright/web-components';
import styled from 'styled-components';
import LargeHeaderWithNav from '../../layouts/large-header-with-nav-layout';

const ContentContainer = styled.div`
  max-width: 32rem;
  width: 100%;
  margin: 1.25rem auto;
  justify-content: center;
`;

interface ErrorPageProps {
  title?: string;
  message?: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ title, message }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const errorMessage = message || searchParams.get('message') || 'An unexpected error occurred.';
  const errorTitle = title || 'Ooops something went wrong';

  return (
    <LargeHeaderWithNav>
      <div className="step-body">
        <ContentContainer>
          <Alert
            title={errorTitle}
            body={
              <div>
                <p>{errorMessage}</p>
              </div>
            }
            outcome="error"
            icon={<IconAttention />}
          />
        </ContentContainer>
      </div>
    </LargeHeaderWithNav>
  );
};
